import React from 'react';
import debounce from 'lodash/debounce';
import { Select } from 'antd';
import styles from './tag-multiple-select.module.sass';

class TagMultipleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.search = debounce(this.search, 100);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref && this.ref.current.focus();
    this.setState({
      value: null,
    });
  }

  state = {
    value: null,
    searchValue: '',
  };

  search = (value) => {
    this.props.searchForTags(value);
  };

  handleSearch = (searchValue) => {
    let value = searchValue;
    if (value.length > 20) value = value.slice(0, 20);
    this.setState({ searchValue: value });
    this.search(value);
  };

  handleChange = (value) => {
    this.setState({ value });
  };

  handleSelect = (value, tag) => {
    this.setState({ searchValue: '' });
    // console.log(value);
    // console.log(tag);
    // let tagObject = {
    //   id: tag?.id,
    //   name: tag?.value,
    //   expiration: tag?.expiration,
    // };
    let tags = sessionStorage.getItem('tags')
      ? JSON.parse(sessionStorage.getItem('tags'))
      : [];
    //tags = tags.concat(value);
    tags = [...tags, value];
    //tags = [...tags, tagObject];
    // console.log('tags');
    // console.log(tags);
    sessionStorage.setItem('tags', JSON.stringify(tags));
    //window.sessionStorage.setItem('tags', value);
    //this.props.addIOCTag([{ id: tag.id, name: tag.value }], scoreDetails);
  };

  handleDeselect = (value) => {
    // console.log('deselect');
    //const tag = scoreDetails.tags.find((t) => t.name === value);
    //if (!tag) return;
    // this.props.removeIOCTag({ id: tag.id, name: value }, scoreDetails);
  };

  render() {
    const options = this.props.foundTags?.map((tag) => ({
      label: `${tag.label}${tag.isNew ? ' (create new)' : ''}`,
      value: tag?.value?.toString(),
      id: tag.id,
      expiration: tag?.expiration ?? null,
    }));

    return (
      <Select
        mode="tags"
        ref={this.ref}
        className={styles.select}
        placeholder="Tag Name"
        //value={this.state.value}
        searchValue={this.state.searchValue}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        onBlur={this.props.onBlur}
        onSelect={this.handleSelect}
        onDeselect={this.handleDeselect}
        notFoundContent={null}
        options={options}
        filterOption={false}
      />
    );
  }
}

export default TagMultipleSelect;
